import { render, staticRenderFns } from "./projetcInfo.vue?vue&type=template&id=2088f450&scoped=true&"
import script from "./projetcInfo.vue?vue&type=script&lang=js&"
export * from "./projetcInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2088f450",
  null
  
)

export default component.exports